<div class="dialog-container">
  <div class="gb-dialog-header">
    <h1>
      {{ dialogTitleKey | translate }}
    </h1>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="gb-dialog-content">
    <form [formGroup]="addSlideForm">
      <mat-form-field>
        <mat-label translate="PROJECTOR.SLIDE_NAME"> </mat-label>

        <input matInput formControlName="slide_name" #input />

        @if (!!slide_name?.hasError('required')) {
          <mat-error translate="FORMS.ERROR.FIELD_REQUIRED"></mat-error>
        }
      </mat-form-field>

      @if (dialogMode === 'create') {
        <mat-checkbox formControlName="use_template" class="use-template-checkbox">
          {{ 'PROJECTOR.USE_TEMPLATE' | translate }}
        </mat-checkbox>

        <div class="templates-wrapper" [class.expanded]="use_template?.value">
          <div class="templates-clip">
            <div class="templates-section">
              <gb-presenter-templates-list></gb-presenter-templates-list>
            </div>
          </div>
        </div>
      }
    </form>
  </div>
  <div class="gb-flex-button-container gb-dialog-actions-container">
    <button
      [disabled]="(editCreateLoaded$ | async) === false || (use_template?.value && !(selectedTemplate$ | async)?.uuid)"
      mat-flat-button
      (click)="submit()"
    >
      @if (editCreateLoaded$ | async) {
        <span>{{ 'PROJECTOR.DONE' | translate }}</span>
      } @else {
        <div class="button-spinner-container">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      }
    </button>
  </div>
</div>
